import * as React from 'react';
import { CommonUtils } from '../util/CommonUtils';
import PropTypes from 'prop-types';

const commonUtils = new CommonUtils();

const getTrimmedTextIfContainsGTSign = (text) => {
    return text && text.indexOf('>') !== -1 ? text.replace('>', '') : '';
}

export const PromoBox = (props) => {
    if(!props.promoBoxDetails) { return null; }

    const trimmedOfferDetailsText = getTrimmedTextIfContainsGTSign(
      props.promoBoxDetails.seeOfferDetails &&
        props.promoBoxDetails.seeOfferDetails.seeOfferDetailsText
    );

    return (
        <div className={'promo-well'}>
            <div className={'promo-well-main'}>
                {props.promoBoxDetails.promoText && props.promoBoxDetails.promoText !== '' ?
                    <h2 id="offerText" className={'offer-text'}>{commonUtils.scanForHTMLElement(props.promoBoxDetails.promoText)}</h2>
                    : null}
                {props.promoBoxDetails.promoCodeText && props.promoBoxDetails.promoCodeText !== '' ?
                    <div id="offerCodeText" className={'offer-code-text'}>{commonUtils.scanForHTMLElement(props.promoBoxDetails.promoCodeText)}</div>
                    : null}
                {props.promoBoxDetails.seeOfferDetails && props.promoBoxDetails.seeOfferDetails.offerDetailsLink && props.promoBoxDetails.seeOfferDetails.offerDetailsLink !== '' ?
                    <div className={'see-offer-details-text'}>
                        <a href={props.promoBoxDetails.seeOfferDetails.offerDetailsLink} 
                            className={trimmedOfferDetailsText ? 'gtSign' : ''}
                            aria-describedby="offerText offerCodeText"
                            aria-label={trimmedOfferDetailsText}
                            >
                                {
                                    trimmedOfferDetailsText || 
                                    props.promoBoxDetails.seeOfferDetails.seeOfferDetailsText
                                }
                        </a>
                    </div>
                    : null}
            </div>
        </div>
    );
};


PromoBox.propTypes = {
    promoBoxDetails: PropTypes.object
};

PromoBox.defaultProps = {
    promoBoxDetails: undefined
};
